import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';

import * as Sentry from '@sentry/angular';
import packageInfo from 'package.json';

// todo - maybe instead of init from dynamic config create separated, native apps-like, unique file like sentry.config.json,
// which would simply be like "{ sentryDsn: string }" to allow direct import via "import sentryDsn from 'sentry.config.json';"
// and this hook for dynamic config would be redundant -
// this would prevent catching which config/env/app is currently loaded
// and make it absolutly clean on which config is loaded (with no need to keep multiple sentry configs in repo)
fetch(import.meta.env?.['NG_APP_BWM_JSON_CONFIG'] || './assets/config/default.json')
  .then(r => r.json())
  .then(config => {
    if(config?.sentryDsn) {
      Sentry.init({
        dsn: config?.sentryDsn,
          environment: 'production',
          release: packageInfo.version ?? 'Unknown version',
          integrations: [
            // Registers and configures the Tracing integration,
            // which automatically instruments your application to monitor its
            // performance, including custom Angular routing instrumentation
            Sentry.browserTracingIntegration(),
            // Registers the Replay integration,
            // which automatically captures Session Replays
            Sentry.replayIntegration(),
          ],

          // Set tracesSampleRate to 1.0 to capture 100%
          // of transactions for tracing.
          // We recommend adjusting this value in production
          tracesSampleRate: 1.0,

          // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled [/^https:\/\/yourserver\.io\/api/]
          tracePropagationTargets: [/^https:\/\/bwm\.bcas\.cz/, ],

          // Capture Replay for 10% of all sessions,
          // plus for 100% of sessions with an error
          replaysSessionSampleRate: 0,
          replaysOnErrorSampleRate: 1.0,
      });
    } else {
      console.warn('Sentry config missing, not initializing it.')
    }
  })
  .finally(() => {
    platformBrowser().bootstrapModule(AppModule, {
      ngZoneEventCoalescing: true,
    })
    .catch(err => console.error(err));
  }
);
